import React from "react";
import classNames from 'classnames';

import { ReactComponent as CloseIcon } from 'Icons/closeFilled.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import rfq from "Reducers/rfq";
import Pdf from "react-to-pdf";
import PRFormat from "Components/PRFormat";
import Upload from 'Components/Upload';
import { isAdaniWilmar } from "Utils/index";

const pdfRef = React.createRef();

const RFQBottomSticky = ({setNextView, setPreviousView, activeView, saveAndClose, discardRfq, viewMode, disableSubmitTrips, toggleConfirmation, serviceType, addCourierTrips, rfqType, addingTrip, rfq, warehouseTripsFilled, procurementList, uploadExistingTripsRemarks, downloadExistingTripsRemarks }) => {
    const nextDisabled = rfq.type === 8 && !(rfq.rfqDetails.contractTenureTo && rfq.biddingDetails.to && (rfq.deliveryDays || {}).value && (rfq.deliveryDays || {}).unit && (rfq.biddingDetails || {}).paymentTerms && (rfq.rfqDetails || {}).serviceModeName) || '';
    return (
        <div className={"pf box-shadow ht-60 bg-white b-0 col-1 z-501"}>
            <div className="container col-1 flex flex-middle flex-between row-100">
                <div className="flex flex-middle">
                    {!viewMode && <div className="flex flex-middle mr-30 curP" onClick={saveAndClose}>
                        <CloseIcon />
                        <span className="pl-10 fBold theme-color fs-18" >Save and Close </span>
                    </div>}
                    {!viewMode && <div className="flex flex-middle select-icon curP" onClick={discardRfq}>
                        <TrashIcon />
                        <span className="pl-10 fBold theme-color fs-18">Discard RFQ </span>
                    </div>}
                </div>
                <div className="flex flex-middle">
                    {/* <button className="ht-40 br-20 border-light blur-dark-color fs-16 fBold pl-30 pr-30 mr-30">Proceed to Preview</button> */}
                    {activeView === 2 && !viewMode &&  rfqType === 1 && isAdaniWilmar() &&
                    <>
                        {/* <a className="ht-25 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 lh-18 mr-20" onClick={this.props.downloadTrips} href={this.props.downloadTripsUrl}>Download Remarks</a> */}
                        <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={downloadExistingTripsRemarks}>Download Remarks</button> 
                        <Upload onChange={uploadExistingTripsRemarks} value="Upload File">
                            <button className="flex flex-center flex-middle ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-15 mr-20 lh-17">Upload Remarks</button>
                        </Upload>
                    </>}
                    {![7].includes(rfqType) ? <>
                    {activeView > 1 && ((activeView === 2 && rfqType === 6) ? !addingTrip : true) && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={setPreviousView}>Previous</button>}
                    {activeView <2  && 
                    <>
                        {rfq.type !== 8 ?
                            <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={setNextView}>Next</button> :
                            <button className={classNames("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30", 
                            { "bg-gray curNA": nextDisabled })} 
                            onClick={setNextView} 
                            disabled={nextDisabled}>Next</button>
                        }
                    </>}
                    {activeView === 2 && !viewMode && serviceType && serviceType === 3 && <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={() =>addCourierTrips(1)}>Save</button>}
                    {activeView === 2 && (rfqType === 6 ? !addingTrip : true) && !viewMode &&  <button className={classNames("ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30", { "bg-gray curNA": disableSubmitTrips })} onClick={setNextView} disabled={disableSubmitTrips}>Proceed to Preview</button>}
                    {activeView === 3 && 
                    <>
                        {rfqType === 8 && <Pdf targetRef={pdfRef} filename="PR_format.pdf" options={{
                            // orientation: 'landscape',
                            scale: 2,
                            orientation: 'portrait',
                            // unit: 'in',
                            // format: [8.27, 11.69],
                        }}>
                            {({ toPdf }) => <button className={"ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30"} onClick={toPdf}>Download PR</button>}
                        </Pdf>}
                        <button className={classNames("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30", { "bg-gray curNA": disableSubmitTrips })} onClick={toggleConfirmation} disabled={disableSubmitTrips}>Submit RFQ</button>
                    </>}
                    </> :
                    <button className={classNames("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30", { "bg-gray curNA": !(rfq.rfqDetails.contractTenureTo && rfq.biddingDetails.to && warehouseTripsFilled)})} onClick={toggleConfirmation} disabled={!(rfq.rfqDetails.contractTenureTo && rfq.biddingDetails.to && warehouseTripsFilled)}>Submit RFQ</button>
                    }

                </div>
         </div>
         {rfqType === 8 && <PRFormat pdfRef={pdfRef} rfq={rfq} trips={procurementList}/>}
      </div>
   );
};

export default RFQBottomSticky;